import axios from 'axios';

import { buildApiV2Url } from '../utils/apiUtils';
import { generateApiError } from '../utils/apiErrorMessages';
import { SURVEY_TYPE_COLLECTION_PATH } from '../config/EntityCollectionPathMap';

const removeSurvey = id =>
  axios
    .delete(buildApiV2Url(`${SURVEY_TYPE_COLLECTION_PATH}/${id}`))
    .catch(generateApiError());

export default removeSurvey;
